import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class CollapsibleContent extends Vue {
  @Prop({ default: "$Title" }) title;
  @Prop({ default: "defaultKey" }) collapsibleContentKey;
  @Prop({ default: true }) isHeaderFullyClickable;

  isShowingCollapsibleContent = false;

  @Watch("isShowingCollapsibleContent")
  handleCollapsibleContent() {
    const collapsibleContent = document.getElementById(this.collapsibleContentKey);
    if (!this.isShowingCollapsibleContent) {
      collapsibleContent.style.maxHeight = null;
      collapsibleContent.style.marginTop = null;
    } else {
      collapsibleContent.style.maxHeight = collapsibleContent.scrollHeight + "px";
      collapsibleContent.style.marginTop = "20px";
    }
  }

  onCollapsibleContentHeaderClick() {
    if (this.isHeaderFullyClickable) {
      this.isShowingCollapsibleContent = !this.isShowingCollapsibleContent;
    }
  }

  onToggleButtonClick() {
    if (!this.isHeaderFullyClickable) {
      this.isShowingCollapsibleContent = !this.isShowingCollapsibleContent;
    }
  }
}
